import PrivacyContent from "./privacy-content";

export default PrivacyContent;
